import { OrderPlanningProfile } from "../OrderPlanningProfile";
import { Button, DataSource, HorizontalSpacer, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutOrderPlanningProfileFilter extends Layout {
    buttonApply: Button;
    buttonCancel: Button;
    buttonReset: Button;
    horizontalspacer1: HorizontalSpacer;
    labelAdvancedFilter: Label;
    layoutProfile: OrderPlanningProfile;
    panelContent: Panel;
    panelHeader: Panel;
    sourceOrderPlanningProfile: DataSource;
}
